module.exports = __webpack_public_path__ + "static/img/choose_1_1.2e216de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/choose_1_1.png
// module id = 6X+4
// module chunks = 0